import React from 'react';
import { Link } from 'react-router-dom';

// Get CDN URL from environment, fallback to local paths
const CDN_URL = import.meta.env.VITE_CDN_URL || '';

/**
 * Logo Component
 *
 * Displays OutdoorGuides branded logo with responsive variants.
 * Logos are served from CloudFront CDN for optimal performance.
 *
 * @param {string} className - Additional CSS classes
 * @param {string} variant - Logo display variant
 *   - 'auto' (default): Responsive - detailed on desktop (≥768px), simplified on mobile
 *   - 'detailed': Always show Logo-01 (full compass icon)
 *   - 'simplified': Always show Logo-02 (simplified compass)
 *
 * Examples:
 *   <Logo />                         // Responsive (auto)
 *   <Logo variant="detailed" />      // Always detailed
 *   <Logo className="h-12" />        // Custom height
 */
export default function Logo({ className = '', variant = 'auto' }) {
  return (
    <Link
      to="/"
      className={`inline-block focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 rounded ${className}`}
      aria-label="OutdoorGuides home"
    >
      {/* Responsive Logo: Detailed on desktop, simplified on mobile */}
      {variant === 'auto' && (
        <>
          <img
            src={`${CDN_URL}/logos/logo-01.svg`}
            alt="OutdoorGuides"
            className="hidden md:block h-14 md:h-16 w-auto"
            onError={(  _e) => { _e.target.src = `${CDN_URL}/logos/logo-01.png`; }}
          />
          <img
            src={`${CDN_URL}/logos/logo-02.svg`}
            alt="OutdoorGuides"
            className="block md:hidden h-14 w-auto"
            onError={(  _e) => { _e.target.src = `${CDN_URL}/logos/logo-02.png`; }}
          />
        </>
      )}

      {/* Force detailed logo */}
      {variant === 'detailed' && (
        <img
          src={`${CDN_URL}/logos/logo-01.svg`}
          alt="OutdoorGuides"
          className="h-14 md:h-16 w-auto"
          onError={(  _e) => { _e.target.src = `${CDN_URL}/logos/logo-01.png`; }}
        />
      )}

      {/* Force simplified logo */}
      {variant === 'simplified' && (
        <img
          src={`${CDN_URL}/logos/logo-02.svg`}
          alt="OutdoorGuides"
          className="h-14 w-auto"
          onError={(  _e) => { _e.target.src = `${CDN_URL}/logos/logo-02.png`; }}
        />
      )}
    </Link>
  );
}
